import type { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { appStorage, runtimeConfig } from './platform/runtime';

const createStateStore = () =>
  new WebStorageStateStore({ store: appStorage.local as Storage });

export const oidcConfig: AuthProviderProps = {
  authority: runtimeConfig.oidc.authority,
  client_id: runtimeConfig.oidc.clientId,
  redirect_uri: runtimeConfig.oidc.redirectUri,
  response_type: 'code',
  scope: runtimeConfig.oidc.scope,
  post_logout_redirect_uri: runtimeConfig.oidc.postLogoutRedirectUri,
  silent_redirect_uri: runtimeConfig.oidc.silentRedirectUri,
  automaticSilentRenew: false,
  monitorSession: false,
  loadUserInfo: false,
  userStore: createStateStore(),
  stateStore: createStateStore(),
};
